import restClient from "../restClient";

const applyAccountToken = (data) => {
  if (data?.session_expired === true) {
    localStorage.removeItem("token");
    return data;
  }
  if (data?.jwt && typeof data.jwt === "string") {
    localStorage.setItem("token", data.jwt);
  }
  return data;
};

export const getAccount = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      return null;
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`account`, config);
    return applyAccountToken(response.data);
  } catch (err) {
    console.log(err);
    const status = err?.response?.status;
    // Token/Session expired ise kullanıcıyı çıkış ekranına yönlendirebilmek için
    // session_expired akışını tetikliyoruz.
    if (status === 401 || status === 403) {
      localStorage.removeItem("token");
      return { session_expired: true };
    }
    throw err;
  }
};

export const changePassword = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post(`auth/change-password`, data, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const updateSelectedTenant = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(`account/selected-tenant`, data, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
